import { render } from "./PositionSelector.vue?vue&type=template&id=0f881780"
import script from "./PositionSelector.vue?vue&type=script&lang=js"
export * from "./PositionSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__